import { render, staticRenderFns } from "./AppGame.vue?vue&type=template&id=ad295c86&"
import script from "./AppGame.vue?vue&type=script&lang=js&"
export * from "./AppGame.vue?vue&type=script&lang=js&"
import style0 from "./AppGame.vue?vue&type=style&index=0&id=ad295c86&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports